import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import ChoosePlatform from '@/components/platform/copySpeach/ChoosePlatform.vue';
import ChooseSpeach from '@/components/platform/copySpeach/ChooseSpeach.vue';
import { CATEGORIES_LIST, DESTINATION_PLATFORM, RESET_AUTHORS_LIST, RESET_CONFIGURE_SPEACH, RESET_STORE_COPY_SPEACH, SOURCE_PLATFORM } from '@/store/actions/speach';
import ConfigureSpeach from '@/components/platform/copySpeach/ConfigureSpeach.vue';
import ResultCopySpeach from '@/components/platform/copySpeach/ResultCopySpeach.vue';
import { router } from "@/router";
import CenterTop from "@/components/layout/CenterTop.vue";
var CopySpeach = /*#__PURE__*/function (_Vue) {
  function CopySpeach() {
    var _this;
    _classCallCheck(this, CopySpeach);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CopySpeach, [].concat(args));
    _defineProperty(_this, "activeStep", 0);
    _defineProperty(_this, "lastStepButtonsEnabled", false);
    return _this;
  }
  _inherits(CopySpeach, _Vue);
  return _createClass(CopySpeach, [{
    key: "mounted",
    value: function mounted() {
      if (!this.isCopySpeachEnabled) {
        this.goToHome();
      }
      this.activeStep = 0;
      store.dispatch(RESET_STORE_COPY_SPEACH);
    }
    // -- Computed variables
  }, {
    key: "listCheckedSpeach",
    get: function get() {
      return store.getters.listCheckedSpeach;
    }
  }, {
    key: "listSpeachToCopy",
    get: function get() {
      return store.getters.listSpeachToCopy;
    }
  }, {
    key: "nextEnabled",
    get: function get() {
      switch (this.activeStep) {
        case 0:
          return this.sourcePlatform !== null;
        case 1:
          return this.listCheckedSpeach.length !== 0;
        case 2:
          return this.destinationPlatform !== null;
        case 3:
          return this.listSpeachToCopy.length !== 0 && this.listSpeachToCopy.find(function (c) {
            return c.userCopy == null || c.categoryCopy == null;
          }) == null;
        case 4:
          return false;
        default:
          return true;
      }
    }
  }, {
    key: "iconRightNext",
    get: function get() {
      return this.activeStep < 3 ? 'arrow-right' : '';
    }
  }, {
    key: "iconLeftNext",
    get: function get() {
      return this.activeStep === 3 ? 'check' : '';
    }
  }, {
    key: "labelNext",
    get: function get() {
      return this.activeStep === 3 ? this.$t('copy_speaches.steps_navigate_buttons.finish').toString() : this.$t('copy_speaches.steps_navigate_buttons.next').toString();
    }
    // -- CUSTOM FUNCTIONS
  }, {
    key: "selectSourcePlaform",
    value: function selectSourcePlaform(platform) {
      store.dispatch(RESET_STORE_COPY_SPEACH);
      store.dispatch(SOURCE_PLATFORM, platform);
      if (platform) {
        store.dispatch(CATEGORIES_LIST, {
          platformID: platform.platformID
        });
      }
    }
  }, {
    key: "selectDestinationPlatform",
    value: function selectDestinationPlatform(platform) {
      store.dispatch(RESET_CONFIGURE_SPEACH);
      store.dispatch(DESTINATION_PLATFORM, platform);
      if (platform) {
        store.dispatch(CATEGORIES_LIST, {
          platformID: platform.platformID
        });
        store.dispatch(RESET_AUTHORS_LIST, platform.platformID);
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      store.dispatch(RESET_STORE_COPY_SPEACH);
      this.activeStep = 0;
      this.lastStepButtonsEnabled = false;
    }
  }, {
    key: "enableLastStepButtons",
    value: function enableLastStepButtons() {
      this.lastStepButtonsEnabled = true;
    }
  }, {
    key: "goToHome",
    value: function goToHome() {
      this.reset();
      router.push({
        name: 'HomePage'
      });
    }
  }, {
    key: "updateActiveStep",
    value: function updateActiveStep(newActiveStepNumber) {
      if (this.activeStep === 1 && newActiveStepNumber === 2) {
        store.dispatch(RESET_CONFIGURE_SPEACH);
        store.dispatch(DESTINATION_PLATFORM, null);
      }
      this.activeStep = newActiveStepNumber;
    }
  }, {
    key: "sourcePlatform",
    get: function get() {
      return store.getters.sourcePlatform;
    }
  }, {
    key: "destinationPlatform",
    get: function get() {
      return store.getters.destinationPlatform;
    }
  }, {
    key: "isCopySpeachEnabled",
    get: function get() {
      return store.getters.isCopySpeachEnabled;
    }
  }]);
}(Vue);
CopySpeach = __decorate([Options({
  components: {
    ResultCopySpeach: ResultCopySpeach,
    ChooseSpeach: ChooseSpeach,
    ChoosePlatform: ChoosePlatform,
    CenterTop: CenterTop,
    ConfigureSpeach: ConfigureSpeach
  }
})], CopySpeach);
export default CopySpeach;